<div #overlay class="overlay">
    <div class="content center-content">
        <div class="column-flex">
            <mat-icon svgIcon="unlocked" data-cy="vessel-folder-unlock-version-unlock-icon" />
            <div class="approve-title" data-cy="vessel-folder-unlock-version-confirmation-modal-header">
                {{ 'unlock.vessel.dialog.title' | translate }}
            </div>
            <div class="approve-message" data-cy="vessel-folder-unlock-version-confirmation-modal-body">
                {{ 'unlock.vessel.dialog.message' | translate }}
            </div>
            <div class="buttons-container">
                <div
                    class="cancel button"
                    data-cy="vessel-folder-unlock-version-confirmation-modal-cancel-btn"
                    (click)="cancel()">
                    {{ 'unlock.vessel.dialog.button.cancel' | translate }}
                </div>
                <div
                    class="create button"
                    data-cy="vessel-folder-unlock-version-confirmation-modal-confirm-btn"
                    (click)="acceptUnlock()">
                    {{ 'unlock.vessel.dialog.button.confirm' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
